import { EventsScreen } from '@/components/domain/events/EventsScreen';

export default function EventsUpcoming() {
  return <EventsScreen initialListType="upcoming" />;
}
